import type { PropsWithChildren, JSX } from "react"
import { isArray } from "lodash"
import { DeepReadonly } from "ts-essentials"
import { InfoOutlined } from "@mui/icons-material"
import OPTooltip from "components/material/tooltip"
import "./styles.scss"
import { TOOLTIP_ENTER_DELAY_MS } from "helpers/constants"

interface InfoTooltipProps {
  title: string | readonly (string | JSX.Element)[]
  hideIcon?: boolean
}

export default function InfoTooltip({ title, children, hideIcon = false }: DeepReadonly<PropsWithChildren<InfoTooltipProps>>) {
  let formattedTitle = title
  if (isArray(title)) {
    formattedTitle = title.map((singleTitle, index) => {
      return <div key={`${index}-${title[0]}`}>
        {index > 0 && <div className="break" />}
        <div>{singleTitle}</div>
      </div>
    })
  }

  return <OPTooltip
    enterDelay={TOOLTIP_ENTER_DELAY_MS}
    title={formattedTitle}
    placement="bottom-start"
  >
    <div className="components_info-tooltip">
      {!hideIcon && <InfoOutlined fontSize="small" />}
      {children}
    </div>
  </OPTooltip>
}
